import { cn } from "@/lib/utils";

export function KeyDatesTable({
  rows = [],
  testId,
  className,
}) {
  return (
    <div
      data-testid={testId}
      className={cn(
        "w-full overflow-hidden rounded-lg border border-slate-200 bg-white shadow-sm",
        className
      )}
    >
      <table className="w-full border-collapse">
        <thead>
          <tr>
            <th className="w-1/2 bg-slate-900 px-5 py-3.5 text-left text-xs font-bold uppercase tracking-wider text-slate-100">
              Event
            </th>

            <th className="w-1/2 bg-slate-900 px-5 py-3.5 text-left text-xs font-bold uppercase tracking-wider text-slate-100">
              Date
            </th>
          </tr>
        </thead>

        <tbody>
          {rows.map((row, index) => {
            // Supports existing array format:
            // ["Application Opens", "October 1, 2026"]

            // Also supports object format:
            // { event: "...", date: "..." }

            const isObject =
              row &&
              typeof row === "object" &&
              !Array.isArray(row);

            const event = isObject
              ? row.event ??
                row.name ??
                row.title ??
                row.label ??
                row[0]
              : row?.[0];

            const date = isObject
              ? row.date ??
                row.value ??
                row[1]
              : row?.[1];

            return (
              <tr
                key={index}
                className={cn(
                  index % 2 === 1
                    ? "bg-slate-50"
                    : "bg-white"
                )}
              >
                <td className="w-1/2 border-b border-slate-100 px-5 py-4 align-top text-sm font-semibold text-slate-900">
                  {event}
                </td>

                <td className="w-1/2 border-b border-slate-100 px-5 py-4 align-top text-sm text-slate-600">
                  {date}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}